export default function createOptions(method: string = 'GET', body: any = {}) {
    let headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
    const user = localStorage.getItem('user');
    if (user) {
        const json = JSON.parse(user);
        if (json) {
            const access_token = json.hasOwnProperty('access_token') ? json.access_token : '';
            if (access_token) headers['Authorization'] = 'Bearer ' + access_token
        }
    }
    method = method.toUpperCase();

    if (method === 'CREATE') {
        method = 'POST';
    }
    if (method === 'READ') {
        method = 'GET';
    }
    if (method === 'UPDATE') {
        method = 'PUT';
    }

    let options = {
        method: method,
        headers: headers
    }
    if (['POST', 'PUT', 'DELETE'].includes(method)) {
        options['body'] = JSON.stringify(body)
    }

    return options;
}